<template>
  <div class="view-wrapper">
    <FullCalendarWrapper
      :events="eventsByViewType"
      @change-view-type="changeView"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import isEmpty from 'lodash/isEmpty';
import { formatCalendarEvents } from '../helpers/events.helper';
import FullCalendarWrapper from './Calendar/FullCalendarWrapper.vue';
import { useEventsStore } from '../../../../stores/eventsStore.js';

defineOptions({
  name: 'EventsCalendarView',
});

const eventsStore = useEventsStore();

const viewType = ref(undefined);

const allEvents = computed(() => eventsStore.allEvents);
const sections = computed(() => eventsStore.sections);
const selectedCalendars = computed(() => eventsStore.selectedCalendars);

const eventsByViewType = computed(() => {
  if (!allEvents.value?.length) {
    return [];
  }
  return allEvents.value.reduce(formatCalendarEvents(viewType.value), []);
});

onMounted(() => {
  if (isEmpty(selectedCalendars.value)) {
    eventsStore.initSelectedCalendars(sections.value.flatMap((item) => item.id));
  }
});

function changeView(type) {
  viewType.value = type;
}
</script>

<style lang="scss" scoped>
.view-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  .view-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 24px;

    .view-header-left,
    .view-header-right {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
